import styled from 'styled-components';
import { background, border, color, flexbox, grid, layout, position, shadow, space, typography } from 'styled-system';
import sx from './sx';
var Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "nv15kw-0"
})(space, color, typography, layout, flexbox, grid, background, border, position, shadow, sx);
export default Box;